export default __webpack_public_path__ + "static/media/drone.0d5ed475.png";